import request from '@/utils/request'

// 查询公海池数据
export function listPublicPool(query) {
  return request({
    url: '/visualization/enterpriseManagement/publicPool/list',
    method: 'get',
    params: query
  })
}

//查询企业详情
export function getEnterpriseDetail(query) {
  return request({
    url: '/visualization/enterpriseManagement/detail',
    method: 'get',
    params: query
  })
}


//查询企业资质列表
export function getQualQualificationList(query) {
  return request({
    url: '/visualization/enterpriseManagement/detail/qualificationList',
    method: 'get',
    params: query
  })
}

//查询企业联系人列表
export function getEnterprisepPrsonList(query) {
  return request({
    url: '/visualization/enterpriseManagement/detail/personList',
    method: 'get',
    params: query
  })
}

//领取企业
export function claimEnterprise(data) {
  return request({
    url: '/visualization/enterpriseManagement/claim',
    method: 'post',
    data: data
  })
}

//客户管理-------------------------------------------------------------
//我的客户
export function listMyCustomer(query) {
  return request({
    url: '/visualization/enterpriseManagement/myCustomer/list',
    method: 'get',
    params: query
  })
}

//新增联系人
export function addPerson(data) {
  return request({
    url: '/visualization/enterpriseManagement/person/add',
    method: 'post',
    data: data
  })
}

//编辑联系人
export function updatePerson(data) {
  return request({
    url: '/visualization/enterpriseManagement/person/edit',
    method: 'post',
    data: data
  })
}

//编辑企业信息
export function updateEnterprise(data) {
  return request({
    url: '/visualization/enterpriseManagement/enterprise/edit',
    method: 'post',
    data: data
  })
}

//新增跟进记录

export function addFollowUp(data) {
  return request({
    url: '/visualization/enterpriseManagement/followUp/add',
    method: 'post',
    data: data
  })
}

//意向记录修改和维护
export function addOrUpdateEnterpriseIntention(data) {
  return request({
    url: '/visualization/enterpriseManagement/intention/save',
    method: 'post',
    data: data
  })
}

//待办提醒维护
export function addTodo(data) {
  return request({
    url: '/visualization/enterpriseManagement/todo/save',
    method: 'post',
    data: data
  })
}

//退回公海
export function returnToPublicPool(data) {
  return request({
    url: '/visualization/enterpriseManagement/return',
   method: 'post',
    data: data
  })
}

//新增资质
export function addQualification(data) {
  return request({
    url: '/visualization/enterpriseManagement/qualification/add',
    method: 'post',
    data: data
  })
}

//编辑资质
export function updateQualification(data) {
  return request({
    url: '/visualization/enterpriseManagement/qualification/edit',
    method: 'post',
    data: data
  })
}

//删除资质
export function deleteQualification(data) {
  return request({
    url: '/visualization/enterpriseManagement/qualification/delete',
    method: 'post',
    data: data
  })
}

//意向列表

export function getIntentionList(query) {
  return request({
    url: '/visualization/enterpriseManagement/detail/intentionList',
    method: 'get',
    params: query
  })
}

//修改意向
export function updateIntention(data) {
  return request({
    url: '/visualization/enterpriseManagement/detail/editIntention',
    method: 'post',
    data: data
  })
}

//我的联系人
export function getMyCustomerPersonList(query) {
  return request({
    url: '/visualization/enterpriseManagement/myCustomer/personList',
    method: 'get',
    params: query
  })
}


//查询跟进记录
export function getFollowUpList(query) {
  return request({
    url: '/visualization/enterpriseManagement/followUp/list',
    method: 'get',
    params: query
  })
}

//我的跟进记录
export function getMyFollowUpList(query) {
  return request({
    url: '/visualization/enterpriseManagement/myFollowUp/list',
    method: 'get',
    params: query
  })
}

//我的待办
export function getMyTodoList(query) {
  return request({
    url: '/visualization/enterpriseManagement/myTodo/list',
    method: 'get',
    params: query
  })
}

//联系人详情
export function getPersonDetail(query) {
  return request({
    url: '/visualization/enterpriseManagement/person/detail',
    method: 'get',
    params: query
  })
}


//新增工作记录
export function addWorkReport(data) {
  return request({
    url: '/visualization/enterpriseManagement/workReport/add',
    method: 'post',
    data: data
  })
}


//查询工作记录
export function getWorkReportList(query) {
  return request({
    url: '/visualization/enterpriseManagement/workReport/list',
    method: 'get',
    params: query
  })
}



//查询企业统计
export function getEnterpriseStatistics(query) {
  return request({
    url: '/visualization/enterpriseManagement/statistics',
    method: 'get',
    params: query
  })
}

//查询每个月的跟进数趋势
export function getFollowUpTrend(query) {
  return request({
    url: '/visualization/enterpriseManagement/dailyFollowUpCount',
    method: 'get',
    params: query
  })
}

//跟进日周月的跟进统计
export function getFollowUpStatistics(query) {
  return request({
    url: '/visualization/enterpriseManagement/followUpStatistics',
    method: 'get',
    params: query
  })
}

//跟进日周月的加微信数统计
export function getWechatStatistics(query) {
  return request({
    url: '/visualization/enterpriseManagement/wechatStatistics',
    method: 'get',
    params: query
  })
}

//获取加微信联系人列表（日/周/月维度）
export function getWechatContactList(query) {
  return request({
    url: '/visualization/enterpriseManagement/wechatPersonList',
    method: 'get',
    params: query
  })
}

//客户类型统计
export function getCustomerTypeStatistics(query) {
  return request({
    url: '/visualization/enterpriseManagement/requirementStatusCount',
    method: 'get',
    params: query
  })
}

//联系人状态统计
export function getPersonStatusStatistics(query) {
  return request({
    url: '/visualization/enterpriseManagement/personStatusCount',
    method: 'get',
    params: query
  })
}

//修改企业名称
export function updateEnterpriseName(data) {
  return request({
    url: 'visualization/enterpriseManagement/updateName',
    method: 'post',
    data: data
  })
}

//加微信操作
export function toggleWechat(data) {
  return request({
    url: '/visualization/enterpriseManagement/toggleWechat',
    method: 'post',
    data: data
  })
}

//每日转化率
export function getDailyConversionRate(query) {
  return request({
    url: '/visualization/enterpriseManagement/dailyConversionRate',
    method: 'get',
    params: query
  })
}


//待办提醒状态统计
export function getTodoStatusStatistics(query) {
  return request({
    url: '/visualization/enterpriseManagement/myTodo/activeList',
    method: 'get',
    params: query
  })
}

//模拟登录
export function mockLogin(data) {
  return request({
    url: '/visualization/enterpriseManagement/mockLogin',
    method: 'post',
    data: data
  })
}

//查询员工列表
export function getStaffList(query) {
  return request({
    url: '/visualization/enterpriseManagement/user/list',
    method: 'get',
    params: query
  })
}

//查询所有企业列表
export function getEnterpriseList(query) {
  return request({
    url: '/visualization/enterpriseManagement/allEnterprise/list',
    method: 'get',
    params: query
  })
}

//总数查询
export function getTotalCount(query) {
  return request({
    url: '/visualization/enterpriseManagement/totalCounts',
    method: 'get',
    params: query
  })
}

//搜索本地企业
export function getLocalEnterpriseList(query) {
  return request({
    url: '/visualization/enterpriseManagement/searchByName',
    method: 'get',
    params: query
  })
}


//导入第三方企业到公海池
export function importThirdPartyEnterprise(data) {
  return request({
    url: '/base/enterpriseCustomerInfo',
    method: 'post',
    data: data
  })
}

//查询手机号关联的企业
export function getEnterpriseByPhone(query) {
  return request({
    url: '/visualization/enterpriseManagement/searchByPhone',
    method: 'get',
    params: query
  })
}

//获取异常信息接口
export function refreshExceptionInfo(query) {
  return request({
    url: '/visualization/enterpriseManagement/queryCertInfo',
    method: 'get',
    params: query
  })
}

// RSA加密
export function rsaEncrypt(data) {
  return request({
    url: '/base/encrypt/rsa',
    method: 'post',
    data: data
  })
}

// 批量导入企业联系人
export function batchImportContacts(data) {
  return request({
    url: '/base/enterprisePersonInfo/batchImportContacts',
    method: 'post',
    data: data
  })
}


//更新企业安许状态
export function updateWslStatus(data) {
  return request({
    url: '/visualization/enterpriseManagement/updateWslState',
    method: 'post',
    data: data
  })
}

// 批量导入企业到公海池
export function batchImportEnterprise(data) {
  return request({
    url: '/visualization/enterpriseManagement/publicPool/importData',
    method: 'post',
    data: data,
    timeout: 10 * 60 * 1000,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}


//设置联系人是否为疑似中介
export function setIsSuspectPerson(data) {
  return request({
    url: '/visualization/enterpriseManagement/detail/markIntermediary',
    method: 'post',
    data: data
  })
}


//设置成无资质
export function setNoQualification(data) {
  return request({
    url: '/visualization/enterpriseManagement/setNoQualification',
    method: 'post',
    data: data
  })
}

//同步企业资质与联系方式
export function syncQualificationAndContacts(data) {
  return request({
    url: '/visualization/enterpriseManagement/syncQualificationAndContacts',
    method: 'post',
    data: data
  })
}

//从Coze同步更新企业资质
export function syncQualificationFromCoze(params) {
  return request({
    url: '/visualization/enterpriseManagement/qualification/syncFromCoze',
    method: 'post',
    params: params
  })
}

//新增资质报价
export function addQualificationQuotation(data) {
  return request({
    url: '/visualization/enterpriseManagement/addQualificationQuotation',
    method: 'post',
    data: data
  })
}

//查询资质报价详情（含人员配置）
export function getQualificationQuotationDetail(query) {
  return request({
    url: '/visualization/enterpriseManagement/qualificationQuotation/detail',
    method: 'get',
    params: query
  })
}

//查询资质报价列表
export function listQualificationQuotation(query) {
  return request({
    url: '/visualization/enterpriseManagement/qualificationQuotation/list',
    method: 'get',
    params: query
  })
}

//保存（修改）人员配置
export function savePersonnelAllocation(data) {
  return request({
    url: '/visualization/enterpriseManagement/savePersonnelAllocation',
    method: 'post',
    data: data
  })
}

//修改用户编辑资质报价权限
export function updateUserCanEdit(data) {
  return request({
    url: '/visualization/enterpriseManagement/updateUserCanEdit',
    method: 'post',
    data: data
  })
}

// 设置用户是否禁止查看报价（showQuotation=1 禁止，传 null 恢复）
export function updateUserShowQuotation(data) {
  return request({
    url: '/visualization/enterpriseManagement/updateUserShowQuotation',
    method: 'post',
    data: data
  })
}

// 编辑资质报价基础信息
export function updateQualificationQuotation(data) {
  return request({
    url: '/visualization/enterpriseManagement/qualificationQuotation/updateBase',
    method: 'post',
    data: data
  })
}

// 更新资质报价排序（置顶/置尾/取消）
// sortType=1 置顶，2 置尾，其他/不传 取消
export function updateQualificationQuotationSort(data) {
  return request({
    url: '/visualization/enterpriseManagement/qualificationQuotation/updateSort',
    method: 'post',
    data: data
  })
}

// 浏览次数 +1
export function incrementViews(query) {
  return request({
    url: '/visualization/enterpriseManagement/qualificationQuotation/incrementViews',
    method: 'post',
    params: query
  })
}

// 删除资质报价（支持单个或批量，infoIds 逗号分隔）
export function delQualificationQuotation(infoIds) {
  return request({
    url: '/visualization/enterpriseManagement/qualificationQuotation/' + infoIds,
    method: 'delete'
  })
}

// 新增人才价格（人员自定义模板）
export function addTalentPrice(data) {
  return request({
    url: '/visualization/enterpriseManagement/talentPrice/add',
    method: 'post',
    data: data
  })
}

// 查询人才价格列表（分页）
export function listTalentPrice(query) {
  return request({
    url: '/visualization/enterpriseManagement/talentPrice/list',
    method: 'get',
    params: query
  })
}

// 修改人才价格
export function updateTalentPrice(data) {
  return request({
    url: '/visualization/enterpriseManagement/talentPrice/update',
    method: 'post',
    data: data
  })
}

// 删除人才价格（支持单个或逗号分隔批量）
export function delTalentPrice(infoIds) {
  return request({
    url: '/visualization/enterpriseManagement/talentPrice/' + infoIds,
    method: 'delete'
  })
}

// 共享文档 - 分页列表（documentName 模糊查询）
export function listSharedDocument(query) {
  return request({
    url: '/visualization/enterpriseManagement/sharedDocument/list',
    method: 'get',
    params: query
  })
}

// 共享文档 - 新增
export function addSharedDocument(data) {
  return request({
    url: '/visualization/enterpriseManagement/sharedDocument/add',
    method: 'post',
    data: data
  })
}

// 共享文档 - 修改
export function updateSharedDocument(data) {
  return request({
    url: '/visualization/enterpriseManagement/sharedDocument/update',
    method: 'post',
    data: data
  })
}

// 共享文档 - 删除（支持单个或逗号分隔批量）
export function delSharedDocument(infoIds) {
  return request({
    url: '/visualization/enterpriseManagement/sharedDocument/' + infoIds,
    method: 'delete'
  })
}


